import type {
  CambiosDePerfil, NuevaReserva, NuevaResena, NuevoReclamo, RespuestaAspectos, RespuestaAvisos,
  RespuestaCancelacion, RespuestaMisDatos, RespuestaReclamo, RespuestaReclamos, RespuestaReservaDeTurno,
  RespuestaTurno, RespuestaTurnosDePaciente, VistaDeTurnos,
} from '@medchoice/shared';
import { request } from './client';

const BASE = '/pacientes/yo';

export const paciente = {
  misDatos: () => request<RespuestaMisDatos>(BASE).then((r) => r.datos),

  actualizar: (cambios: CambiosDePerfil) =>
    request<RespuestaMisDatos>(BASE, { method: 'PATCH', body: cambios }).then((r) => r.datos),

  turnos: (vista: VistaDeTurnos) =>
    request<RespuestaTurnosDePaciente>(`${BASE}/turnos?vista=${vista}`).then((r) => r.turnos),

  reservar: (reserva: NuevaReserva) =>
    request<RespuestaReservaDeTurno>(`${BASE}/turnos`, { method: 'POST', body: reserva }).then((r) => r.turno),

  turno: (id: number) => request<RespuestaTurno>(`${BASE}/turnos/${id}`).then((r) => r.turno),

  cancelar: (id: number, motivo: string) =>
    request<RespuestaCancelacion>(`${BASE}/turnos/${id}/cancelacion`, { method: 'POST', body: { motivo } })
      .then((r) => r.resultado),

  reprogramar: (id: number, fecha: string, hora: string) =>
    request<RespuestaTurno>(`${BASE}/turnos/${id}/reprogramacion`, { method: 'POST', body: { fecha, hora } })
      .then((r) => r.turno),

  resenar: (id: number, resena: NuevaResena) =>
    request<RespuestaTurno>(`${BASE}/turnos/${id}/resena`, { method: 'POST', body: resena }).then((r) => r.turno),

  aspectos: () => request<RespuestaAspectos>(`${BASE}/resenas/aspectos`).then((r) => r.aspectos),

  avisos: () => request<RespuestaAvisos>(`${BASE}/avisos`).then((r) => r.avisos),

  reclamos: () => request<RespuestaReclamos>(`${BASE}/reclamos`).then((r) => r.reclamos),

  reclamar: (reclamo: NuevoReclamo) =>
    request<RespuestaReclamo>(`${BASE}/reclamos`, { method: 'POST', body: reclamo }).then((r) => r.reclamo),
};
